module.exports = __webpack_public_path__ + "static/media/echeck2.5bc3669e.png";